import { useSystemInfo, useSystemViewData } from "../providers/helpers/useSystem"
import { Section, SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"
import { VStack, Skeleton } from "@chakra-ui/react"
import ForecastSummary from "@hydrologiq/shared/forecast/ForecastSummary"
import ForecastChart from "@hydrologiq/shared/forecast/ForecastChart"
import { ForecastProvider } from "@hydrologiq/shared/forecast/ForecastProvider"
import { toUserTZ } from "@hydrologiq/common/helpers/date"

const SystemForecast = () => {
  const info = useSystemInfo()
  const viewData = useSystemViewData()

  // Get the first installation (same logic as SystemMonitoring)
  const [installation, installationInfo] =
    info?.inlineMonitoring || !info?.installations || Object.keys(info?.installations || {}).length === 0
      ? [undefined, undefined]
      : Object.entries(info?.installations)[0]

  const end = installationInfo?.endDate ? toUserTZ(installationInfo?.endDate) : undefined

  return installation && installationInfo ? (
    <SectionRoot>
      <Section separator={false}>
        <ForecastProvider
          entityType="installation"
          installationId={installation}
          siteId={viewData?.system?.siteId ?? undefined}
          customerId={viewData?.system?.customerId ?? undefined}
        >
          <VStack align="stretch" gap={6}>
            <ForecastSummary entityType="installation" installationId={installation} start={end} />
            <ForecastChart
              entityType="installation"
              installationId={installation}
              siteId={viewData?.system?.siteId ?? undefined}
              customerId={viewData?.system?.customerId ?? undefined}
            />
          </VStack>
        </ForecastProvider>
      </Section>
    </SectionRoot>
  ) : (
    <Skeleton height="100%" width="100%" />
  )
}

export default SystemForecast